/**
 * displayName — the one rule for a person's shown name (IDI-550).
 *
 * My Profile given + family name (either alone) → invite name → email.
 * Never the email's local part, never "You" (Sarah L139; Adrian L141).
 * Mirrors middleware.DisplayName in backend-go.
 */
const clean = (v) => (typeof v === 'string' ? v.trim() : '');
const isYou = (s) => /^you$/i.test(s);

export function displayName({ firstName, lastName, name, email } = {}) {
  const full = [clean(firstName), clean(lastName)].filter(Boolean).join(' ');
  if (full) return full;
  const n = clean(name);
  if (n && !isYou(n)) return n;
  return clean(email);
}

/** Legacy label for pre-IDI-305 string notes; shown as stored. */
export const LEGACY_AUTHOR_LABEL = 'Earlier note (author not recorded)';

/**
 * resolveNoteAuthor — what a note shows as its author.
 *   1. the author's CURRENT name, matched on author_id (Cognito sub);
 *   2. else the stored author (a stored "You" names nobody → "Unknown");
 *   3. else "Unknown".
 * Nothing is written back; old notes follow name changes at read time.
 */
export function resolveNoteAuthor(note, namesBySub) {
  const id = clean(note?.author_id || note?.authorId);
  if (id && namesBySub) {
    const current = clean(
      namesBySub instanceof Map ? namesBySub.get(id) : namesBySub[id]
    );
    if (current) return current;
  }
  const stored = clean(note?.author);
  if (!stored || isYou(stored)) return 'Unknown';
  return stored;
}
